var map = {
	"./ar/label.json": 4716,
	"./cz/label.json": 5898,
	"./de/label.json": 4984,
	"./en/label.json": 6460,
	"./fr/label.json": 8347,
	"./it/label.json": 4406,
	"./ja/label.json": 522,
	"./ko/label.json": 8161,
	"./kz/label.json": 4450,
	"./pt/label.json": 975,
	"./sk/label.json": 1685,
	"./sv/label.json": 1734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4642;